import { useCallback } from "react";
import { useModalState } from "clientState/AuthFlow/providers/ModalScreenProvider";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import {
  type CustomContentFromKeysProps,
  type CustomTranslation,
  type CustomTranslationProps,
  type CustomTranslations,
} from "./contract";

const getCustomContentFromKey = ({
  customContent,
  customKey,
  defaultContent,
}: CustomContentFromKeysProps): string => {
  let translation = customContent;
  for (const key of customKey) {
    if (translation && key in translation) {
      translation = translation[key];
    } else {
      return defaultContent;
    }
  }
  if (typeof translation !== "string" && typeof translation !== "boolean") {
    return defaultContent;
  } else {
    return translation;
  }
};

export const useCustomTranslation = (): CustomTranslations => {
  const { customContent } = useModalState();
  const { t } = useTranslation();

  const customTranslation = useCallback(
    ({
      customKey,
      defaultKey,
      args,
    }: CustomTranslationProps): CustomTranslation => {
      if (customContent === undefined) {
        return { content: t(defaultKey, args), showComponent: true };
      }
      const newContent: string | boolean = getCustomContentFromKey({
        customKey: customKey.split("."),
        defaultContent: t(defaultKey, args),
        customContent,
      });

      if (typeof newContent === "boolean") {
        return { content: "", showComponent: false };
      }
      if (newContent.length === 0) {
        return { content: t(defaultKey, args), showComponent: true };
      }
      return { content: newContent, showComponent: true };
    },
    [customContent, t],
  );

  return { customTranslation };
};
